let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j8JVu")).then(() => parcelRequire('5uPg2'));